import React from "react";
import HeroSection from "../pages/HeroSection.js";
import CompanyProfile from "../pages/CompanyProfile.jsx";
import Ctasection from "../pages/Ctasection.jsx";
import ProductGallery from "../pages/ProductGallery.js";
import Carousel from "./Carousel.jsx";

const Home = () => {
  return (
    <div className="homepage-container">
      <HeroSection />
      <Carousel />
      <CompanyProfile />
      <ProductGallery />
      <Ctasection />
    </div>
  );
};

export default Home;
